/* eslint-disable consistent-return,no-param-reassign,no-underscore-dangle,prefer-destructuring */

import { DESIGNER_SETTINGS } from '../../../../../app/constants/designer_settings';
import { getComponentDefaultDataByType } from '../../../../../app/package-designer/helpers/components.helpers';

(function (angular) {
  angular.module('xplenty-designer').factory('DesignerBase', [
    '$location',

    function ($location) {
      function DesignerBase() {
        this._data = null;
        this.element = null;
        this.componentType = null;
        this.cell = DESIGNER_SETTINGS.CELL;
      }

      DesignerBase.prototype.fixData = function (data) {
        if (data === null) return;

        const keys = Object.keys(data);

        if (keys.length === 1) {
          this.componentType = keys[0];

          const dataToMarge = getComponentDefaultDataByType(this.componentType);

          data = dataToMarge !== undefined ? _.extend(dataToMarge, data[this.componentType]) : data[this.componentType];
        }

        return data;
      };

      DesignerBase.prototype.moveToFirst = function () {
        const parent = this.element.parent();
        const first = parent.find('.designer-component, .designer-note').first();
        if (!first.is(this.element)) first.before(this.element);
      };

      DesignerBase.prototype.moveToLast = function () {
        const parent = this.element.parent();
        parent.append(this.element);
      };

      DesignerBase.prototype.absUrl = function () {
        const absUrl = $location.absUrl();

        return absUrl;
      };

      DesignerBase.prototype.snapToGrid = function (value) {
        return Math.round(value / this.cell) * this.cell;
      };

      DesignerBase.prototype.toComponentName = function (str) {
        if (typeof str === 'string') {
          const name = str
            .replace(/[(\-)]/g, '')
            .toLowerCase()
            .replace(/ /g, '_');

          return name;
        }

        return str;
      };

      DesignerBase.prototype.uid = function () {
        return Math.floor((1 + Math.random()) * 0x1000000)
          .toString(16)
          .substring(1);
      };

      return DesignerBase;
    },
  ]);
})(window.angular);
